<template>
    <f7Page no-navbar>
        <f7-subnavbar :inner="false">
            <f7-searchbar
                    placeholder="搜索点读包资源"
                    disable-button-text="清除"
                    search-container=".search-list"
                    search-in=".item-title"
                    customSearch
                    no-hairline
                    @searchbar:search="search"
            ></f7-searchbar>
        </f7-subnavbar>
        <f7-list class="searchbar-not-found">
            <f7-list-item title="无搜索结果"></f7-list-item>
        </f7-list>
        <f7-list class="search-list searchbar-found">
            <section class='goods-items-wrap'>
                <pack-item :pack="pack" v-for="(pack,index) in packList"
                           @click.native="goDetail(pack)"
                           :key="index"></pack-item>
            </section>
        </f7-list>
    </f7Page>
</template>

<script type="text/ecmascript-6">
  import {
    f7Subnavbar,
    f7Searchbar,
    f7List,
    f7ListItem
  } from 'framework7-vue'
  import { globalConst as native } from '../../lib/const'
  import { mapState } from 'vuex'
  import PackItem from 'section/packItem/PackItem'
  import infiniteLoading from 'vue-infinite-loading'
  import debounce from 'lodash/debounce'

  export default {
    data () {
      return {
        packList: []
      }
    },
    created () {
      this.debounceLoadData = debounce(this.loadData, 500)
    },
    mounted () {
      this.$nextTick(() => {
        this.$$('.searchbar  input')[0].focus()
      })
    },
    methods: {
      goDetail (pack) {
        this.$f7router.navigate(`/package/detail/${pack.id}`)
      },
      search (searchbar, query, previousQuery) {
        this.debounceLoadData(searchbar, query)
      },
      loadData (searchbar, query) {
        if (!query) {
          return
        }
        this.$store.dispatch({
          type: native.resSearch,
          keyWord: query,
          index: 0
        }).then(({data}) => {
          this.packList = data
          if (this.packList.length > 0) {
            searchbar.$foundEl.show()
            searchbar.$notFoundEl.hide()
          } else {
            searchbar.$foundEl.hide()
            searchbar.$notFoundEl.show()
          }

        })
      }
    },
    computed: {
      ...mapState({})
    },
    destroyed () {
    },
    components: {f7Subnavbar, f7Searchbar, f7ListItem, f7List, PackItem}
  }
</script>
<style lang="scss" scoped type="text/css">
</style>
